import React, { useState, useEffect } from "react";
import { MapInteractionCSS } from "react-map-interaction";
import "./HomePageSvg.css";

function HomePageSvg({ svgWidth, svgMinWidth }) {
  return (
    <div style={{ width: "auto" }}>
      <svg
        className="zoom-effect"
        width={svgWidth}
        height="auto"
        style={{
          minWidth: svgMinWidth,
          //   minHeight: 278,
          maxWidth: "100%",
        }}
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="newsketches 1" clip-path="url(#clip0)">
          <g id="layer1">
            <g id="path967">
              <path
                d="M7.08809 6.18226L6.8455 6.1547L6.6077 6.20947L6.36678 6.24047L6.12653 6.20479L5.9201 6.15619L5.72007 6.08619L5.49914 6.05886L5.30367 6.16414L5.25681 6.25604L5.16245 6.29965L5.10846 6.38718L5.11854 6.48921L5.28446 6.54762L5.45418 6.5943L5.62872 6.62059L5.79738 6.67204L5.85799 6.75779L5.89261 6.85659L5.88794 6.96419L5.94138 7.05805L6.08533 7.20407L6.28174 7.26652L6.48 7.32199L6.68195 7.28153L6.62189 7.40771L6.50204 7.48139L6.4657 7.61446L6.49682 7.74879L6.58101 7.89005L6.62658 8.04764L6.78376 8.10519L6.90824 8.21606L6.81832 8.3831L6.83469 8.57159L6.86459 8.75073L6.90824 8.92712L6.96744 9.22233L6.83885 9.49515L6.67899 9.75252L6.39395 9.86165L6.0239 9.90986L5.66344 9.81425L5.2982 9.78992L4.93339 9.76006L4.44896 9.68109L3.95805 9.67304L3.50629 9.4774L3.02024 9.39437L2.95952 9.28582L2.98707 9.16482L2.88945 9.09459L2.83511 8.98806L2.47152 8.91494L2.23593 8.63182L1.89305 8.51355L1.66254 8.23639L1.67194 7.78744L1.43856 7.40205L1.09074 7.1377L0.79854 6.81425L0.879487 6.68116L0.915327 6.52997L0.886414 6.37883L0.880823 6.22509L0.729822 5.93199L0.523123 5.67418L0.519785 5.34401L0.428253 5.02646L0.476222 4.81416L0.521026 4.60119L0.599652 4.39282L0.757395 4.23413L0.67805 4.00254L0.582466 3.77702L0.679387 3.55199L0.757395 3.3199L1.01315 3.11654L1.34133 3.10554L1.66683 3.05293L1.88882 2.812L1.95793 2.51588L2.18514 2.31093L2.33351 2.03706L2.25912 1.73527L2.62752 1.6974L2.95017 1.51778L3.31628 1.54227L3.65797 1.67432L4.18135 1.49036L4.6989 1.68977L5.18486 1.46604L5.50938 1.04453L5.69867 1.07744L5.87591 1.15078L6.06271 1.19018L6.24996 1.22737L6.6539 1.28958L6.99882 1.07279L7.37122 1.16195L7.75168 1.20705L7.82133 1.31741L7.93542 1.38233L7.98581 1.50465L7.95739 1.63369L8.10994 1.81001L8.32206 1.90947L8.54844 1.85572L8.78025 1.87748L8.74988 1.96906L8.7188 2.06041L8.68326 2.15028L8.65681 2.24317L8.62833 2.73459L8.75504 3.21063L8.81948 3.71085L8.61567 4.17319L8.57973 4.251L8.51859 4.31157L8.49458 4.39307L8.49225 4.47791L8.22399 4.5889L7.93517 4.62247L7.65525 4.50635L7.36081 4.5795L7.02414 4.88833L7.24269 5.38889L7.14033 5.74681L7.08809 6.18226"
                fill="#D7D7F2"
              />
              <path
                d="M7.08809 6.18226L6.8455 6.1547L6.6077 6.20947L6.36678 6.24047L6.12653 6.20479L5.9201 6.15619L5.72007 6.08619L5.49914 6.05886L5.30367 6.16414L5.25681 6.25604L5.16245 6.29965L5.10846 6.38718L5.11854 6.48921L5.28446 6.54762L5.45418 6.5943L5.62872 6.62059L5.79738 6.67204L5.85799 6.75779L5.89261 6.85659L5.88794 6.96419L5.94138 7.05805L6.08533 7.20407L6.28174 7.26652L6.48 7.32199L6.68195 7.28153L6.62189 7.40771L6.50204 7.48139L6.4657 7.61446L6.49682 7.74879L6.58101 7.89005L6.62658 8.04764L6.78376 8.10519L6.90824 8.21606L6.81832 8.3831L6.83469 8.57159L6.86459 8.75073L6.90824 8.92712L6.96744 9.22233L6.83885 9.49515L6.67899 9.75252L6.39395 9.86165L6.0239 9.90986L5.66344 9.81425L5.2982 9.78992L4.93339 9.76006L4.44896 9.68109L3.95805 9.67304L3.50629 9.4774L3.02024 9.39437L2.95952 9.28582L2.98707 9.16482L2.88945 9.09459L2.83511 8.98806L2.47152 8.91494L2.23593 8.63182L1.89305 8.51355L1.66254 8.23639L1.67194 7.78744L1.43856 7.40205L1.09074 7.1377L0.79854 6.81425L0.879487 6.68116L0.915327 6.52997L0.886414 6.37883L0.880823 6.22509L0.729822 5.93199L0.523123 5.67418L0.519785 5.34401L0.428253 5.02646L0.476222 4.81416L0.521026 4.60119L0.599652 4.39282L0.757395 4.23413L0.67805 4.00254L0.582466 3.77702L0.679387 3.55199L0.757395 3.3199L1.01315 3.11654L1.34133 3.10554L1.66683 3.05293L1.88882 2.812L1.95793 2.51588L2.18514 2.31093L2.33351 2.03706L2.25912 1.73527L2.62752 1.6974L2.95017 1.51778L3.31628 1.54227L3.65797 1.67432L4.18135 1.49036L4.6989 1.68977L5.18486 1.46604L5.50938 1.04453L5.69867 1.07744L5.87591 1.15078L6.06271 1.19018L6.24996 1.22737L6.6539 1.28958L6.99882 1.07279L7.37122 1.16195L7.75168 1.20705L7.82133 1.31741L7.93542 1.38233L7.98581 1.50465L7.95739 1.63369L8.10994 1.81001L8.32206 1.90947L8.54844 1.85572L8.78025 1.87748L8.74988 1.96906L8.7188 2.06041L8.68326 2.15028L8.65681 2.24317L8.62833 2.73459L8.75504 3.21063L8.81948 3.71085L8.61567 4.17319L8.57973 4.251L8.51859 4.31157L8.49458 4.39307L8.49225 4.47791L8.22399 4.5889L7.93517 4.62247L7.65525 4.50635L7.36081 4.5795L7.02414 4.88833L7.24269 5.38889L7.14033 5.74681L7.08809 6.18226"
                stroke="white"
                stroke-width="0.0617657"
              />
            </g>
            <g id="path993">
              <path
                d="M12.19 5.38889L11.8079 5.25361L11.4228 5.38062L11.0879 5.57322L10.7114 5.66418L10.7266 5.75937L10.7958 5.82728L10.787 5.92019L10.8142 6.00956L10.7459 6.12787L10.6509 6.22668L10.6407 6.36186L10.6497 6.49713L10.762 6.51509L10.8555 6.57924L10.9351 6.65904L11.0405 6.70029L11.0076 6.82812L11.0447 6.95481L11.0309 7.08136L11.02 7.20819L11.2336 7.19942L11.4464 7.22074L11.6672 7.209L11.8634 7.30978L11.9491 7.44102L11.9596 7.59687L11.9534 7.74794L11.9457 7.89894L12.1238 8.02487L12.336 8.07832L12.4667 8.26329L12.6862 8.32558L12.5085 8.36323L12.3267 8.36186L12.1503 8.42805L11.9662 8.38652L11.7946 8.51609L11.6161 8.63619L11.3997 8.62464L11.1845 8.65062L11.0156 8.58327L10.8674 8.47862L10.6884 8.41165L10.5057 8.46779L10.333 8.53411L10.1917 8.65236L10.0255 8.73158L9.88854 8.8538L9.60637 8.87902L9.38224 9.0502L9.112 9.01466L8.83939 9.01631L8.88661 9.15928L8.89713 9.30929L9.02558 9.39429L9.10681 9.52421L8.97303 9.57696L8.83446 9.6158L8.68668 9.62415L8.55139 9.56485L8.76213 9.71579L8.89776 9.9352L9.04961 10.1497L9.29196 10.2556L9.38144 10.2043L9.45776 10.1354L9.55748 10.1015L9.66225 10.1134L9.78419 10.2386L9.83103 10.4061L9.95633 10.522L10.0531 10.6619L10.2342 10.5782L10.4332 10.5978L10.5842 10.4795L10.732 10.3572L10.8374 10.5145L10.9728 10.6476L11.1313 10.7527L11.2668 10.8854L11.5496 10.7758L11.8433 10.8522L12.0816 11.0298L12.3777 11.0682L12.3844 11.1623L12.4126 11.2524L12.3443 11.3213L12.3159 11.4136L12.3962 11.4903L12.4269 11.5965L12.5043 11.6731L12.604 11.7183L12.4717 11.7853L12.3614 11.8838L12.2228 11.9595L12.0691 11.9215L11.9676 12.0219L11.9513 12.1628L11.9532 12.2976L11.9251 12.4294L11.8384 12.3962L11.7541 12.3576L11.6656 12.3297L11.5754 12.3075L11.3325 12.3524L11.0877 12.3187L10.8336 12.2886L10.6085 12.4091L10.3319 12.394L10.0806 12.2788L9.81708 12.3825L9.53881 12.3278L9.6771 12.4619L9.83677 12.5703L10.0233 12.6251L10.2177 12.6325L10.2244 12.7655L10.1991 12.8962L10.2994 12.99L10.3411 13.1201L10.5368 13.0906L10.7336 13.0686L10.9383 13.051L11.1228 13.1404L11.5692 13.4033L11.8906 13.8068L12.4046 13.9894L12.9125 13.7906L13.0611 13.7269L13.2119 13.6689L13.3751 13.6603L13.5297 13.6077L13.8135 13.6098L14.0954 13.6423L14.3817 13.6804L14.6611 13.6077L14.8546 13.6836L15.0628 13.6805L15.2704 13.725L15.4222 13.8718L15.7718 13.7173L16.1547 13.7057L16.5299 13.7287L16.9034 13.7703L16.9209 13.6343L16.9848 13.5127L16.9331 13.3878L16.8828 13.2624L16.8773 12.9358L17.0971 12.6918L17.082 12.3862L17.1297 12.084L16.968 11.9768L16.7738 11.9898L16.6847 11.8285L16.5537 11.698L16.6631 11.6414L16.7038 11.5262L16.8012 11.4658L16.9034 11.4136L16.8988 11.2194L17.021 11.0671L17.0796 10.888L17.0474 10.7025L17.3252 10.7978L17.6094 10.7232L17.8808 10.7971L18.1582 10.8448L18.0567 10.7945L17.9845 10.7079L17.9359 10.6088L17.8702 10.5197L17.8561 10.3826L17.9103 10.2556L17.9031 10.1216L17.8702 9.99149L17.7405 9.93541L17.6303 9.84749L17.5419 9.73643L17.4177 9.66642L17.5909 9.59123L17.6641 9.41891L17.7599 9.25957L17.7262 9.07728L17.4811 8.98896L17.2461 8.87697L17.005 8.7733L16.8005 8.61L16.5523 8.62828L16.3086 8.57775L16.0683 8.52275L15.8337 8.44746L15.9538 8.32959L16.0465 8.18965L16.1897 8.1005L16.3479 8.04115L16.3919 7.7121L16.2595 7.40703L16.3009 7.07057L16.1217 6.78156L16.0174 6.47294L15.7409 6.29604L15.4617 6.15488L15.1548 6.09082L15.1241 5.99977L15.0868 5.91115L15.0928 5.81373L15.1342 5.72513L14.841 5.78969L14.5708 5.65996L14.3995 5.4129L14.1057 5.33913L14.0243 5.23544L14.0334 5.10459L13.9212 5.04725L13.8382 4.95312L13.5408 5.00069L13.3488 5.23002L13.0614 5.20386L12.7891 5.2985L12.6269 5.32316L12.4764 5.25871L12.3212 5.29811L12.19 5.38889"
                fill="#F0DDDD"
              />
              <path
                d="M12.19 5.38889L11.8079 5.25361L11.4228 5.38062L11.0879 5.57322L10.7114 5.66418L10.7266 5.75937L10.7958 5.82728L10.787 5.92019L10.8142 6.00956L10.7459 6.12787L10.6509 6.22668L10.6407 6.36186L10.6497 6.49713L10.762 6.51509L10.8555 6.57924L10.9351 6.65904L11.0405 6.70029L11.0076 6.82812L11.0447 6.95481L11.0309 7.08136L11.02 7.20819L11.2336 7.19942L11.4464 7.22074L11.6672 7.209L11.8634 7.30978L11.9491 7.44102L11.9596 7.59687L11.9534 7.74794L11.9457 7.89894L12.1238 8.02487L12.336 8.07832L12.4667 8.26329L12.6862 8.32558L12.5085 8.36323L12.3267 8.36186L12.1503 8.42805L11.9662 8.38652L11.7946 8.51609L11.6161 8.63619L11.3997 8.62464L11.1845 8.65062L11.0156 8.58327L10.8674 8.47862L10.6884 8.41165L10.5057 8.46779L10.333 8.53411L10.1917 8.65236L10.0255 8.73158L9.88854 8.8538L9.60637 8.87902L9.38224 9.0502L9.112 9.01466L8.83939 9.01631L8.88661 9.15928L8.89713 9.30929L9.02558 9.39429L9.10681 9.52421L8.97303 9.57696L8.83446 9.6158L8.68668 9.62415L8.55139 9.56485L8.76213 9.71579L8.89776 9.9352L9.04961 10.1497L9.29196 10.2556L9.38144 10.2043L9.45776 10.1354L9.55748 10.1015L9.66225 10.1134L9.78419 10.2386L9.83103 10.4061L9.95633 10.522L10.0531 10.6619L10.2342 10.5782L10.4332 10.5978L10.5842 10.4795L10.732 10.3572L10.8374 10.5145L10.9728 10.6476L11.1313 10.7527L11.2668 10.8854L11.5496 10.7758L11.8433 10.8522L12.0816 11.0298L12.3777 11.0682L12.3844 11.1623L12.4126 11.2524L12.3443 11.3213L12.3159 11.4136L12.3962 11.4903L12.4269 11.5965L12.5043 11.6731L12.604 11.7183L12.4717 11.7853L12.3614 11.8838L12.2228 11.9595L12.0691 11.9215L11.9676 12.0219L11.9513 12.1628L11.9532 12.2976L11.9251 12.4294L11.8384 12.3962L11.7541 12.3576L11.6656 12.3297L11.5754 12.3075L11.3325 12.3524L11.0877 12.3187L10.8336 12.2886L10.6085 12.4091L10.3319 12.394L10.0806 12.2788L9.81708 12.3825L9.53881 12.3278L9.6771 12.4619L9.83677 12.5703L10.0233 12.6251L10.2177 12.6325L10.2244 12.7655L10.1991 12.8962L10.2994 12.99L10.3411 13.1201L10.5368 13.0906L10.7336 13.0686L10.9383 13.051L11.1228 13.1404L11.5692 13.4033L11.8906 13.8068L12.4046 13.9894L12.9125 13.7906L13.0611 13.7269L13.2119 13.6689L13.3751 13.6603L13.5297 13.6077L13.8135 13.6098L14.0954 13.6423L14.3817 13.6804L14.6611 13.6077L14.8546 13.6836L15.0628 13.6805L15.2704 13.725L15.4222 13.8718L15.7718 13.7173L16.1547 13.7057L16.5299 13.7287L16.9034 13.7703L16.9209 13.6343L16.9848 13.5127L16.9331 13.3878L16.8828 13.2624L16.8773 12.9358L17.0971 12.6918L17.082 12.3862L17.1297 12.084L16.968 11.9768L16.7738 11.9898L16.6847 11.8285L16.5537 11.698L16.6631 11.6414L16.7038 11.5262L16.8012 11.4658L16.9034 11.4136L16.8988 11.2194L17.021 11.0671L17.0796 10.888L17.0474 10.7025L17.3252 10.7978L17.6094 10.7232L17.8808 10.7971L18.1582 10.8448L18.0567 10.7945L17.9845 10.7079L17.9359 10.6088L17.8702 10.5197L17.8561 10.3826L17.9103 10.2556L17.9031 10.1216L17.8702 9.99149L17.7405 9.93541L17.6303 9.84749L17.5419 9.73643L17.4177 9.66642L17.5909 9.59123L17.6641 9.41891L17.7599 9.25957L17.7262 9.07728L17.4811 8.98896L17.2461 8.87697L17.005 8.7733L16.8005 8.61L16.5523 8.62828L16.3086 8.57775L16.0683 8.52275L15.8337 8.44746L15.9538 8.32959L16.0465 8.18965L16.1897 8.1005L16.3479 8.04115L16.3919 7.7121L16.2595 7.40703L16.3009 7.07057L16.1217 6.78156L16.0174 6.47294L15.7409 6.29604L15.4617 6.15488L15.1548 6.09082L15.1241 5.99977L15.0868 5.91115L15.0928 5.81373L15.1342 5.72513L14.841 5.78969L14.5708 5.65996L14.3995 5.4129L14.1057 5.33913L14.0243 5.23544L14.0334 5.10459L13.9212 5.04725L13.8382 4.95312L13.5408 5.00069L13.3488 5.23002L13.0614 5.20386L12.7891 5.2985L12.6269 5.32316L12.4764 5.25871L12.3212 5.29811L12.19 5.38889"
                stroke="white"
                stroke-width="0.0617657"
              />
            </g>
            <g id="path1015">
              <path
                d="M8.71142 1.81874L8.85697 1.80234L9.0498 1.88106L9.25121 1.92555L9.40714 2.06222L9.09793 1.88131L9.09584 1.88499L8.94144 1.79412L8.86602 1.81874L9.30982 2.05746L9.85916 2.36805L10.4873 2.40751L11.1078 2.51449L11.2473 2.52831L11.3671 2.60212L11.4978 2.66146L11.5716 2.78585L11.7549 2.82279L11.9361 2.86979L12.009 3.05944L12.19 3.14766L12.3733 3.21831L12.4606 3.39633L12.6216 3.49376L12.8084 3.50947L12.8967 3.79535L13.0715 4.0369L13.3041 4.22115L13.5814 4.32358L13.5686 4.54251L13.5234 4.757L13.6175 4.95434L13.736 5.13766L13.5194 5.32982L13.4646 5.61621L13.2705 5.83698L13.2722 6.13266L13.2256 6.57389L13.0549 6.98257L12.8092 7.34781L12.6538 7.76083L12.2859 7.95941L11.8814 7.8569L11.4954 7.90632L11.1078 7.94175L10.7839 8.02023L10.4565 8.08229L10.1739 7.90259L9.87095 7.76083L9.62833 7.80725L9.39852 7.71574L9.16968 7.65213L8.94332 7.57991L8.6466 7.41142L8.38365 7.19279L8.04721 7.2638L7.7065 7.2181L7.66725 7.01197L7.51103 6.87409L7.32393 6.77997L7.24267 6.58493L7.20333 6.45836L7.24244 6.33174L7.19715 6.20681L7.08808 6.13266L7.04382 5.88657L7.13649 5.65471L7.13633 5.40078L6.98261 5.20025L6.89964 5.05025L6.84215 4.88847L6.82644 4.71781L6.81476 4.54685L6.75684 4.37038L6.8161 4.19434L6.90593 4.04337L7.00318 3.89716L7.00962 3.70332L7.1267 3.54989L7.29656 3.4741L7.42571 3.33905L7.46687 3.1653L7.45717 2.98691L7.5847 2.86474L7.68353 2.71781L7.72043 2.61803L7.81071 2.56342L7.90476 2.52319L7.97021 2.44376L8.04578 2.38026L8.06476 2.28264L8.05745 2.18725L8.08776 2.09663L8.18839 2.06746L8.28863 2.03695L8.32109 1.92825L8.41686 1.86927L8.51454 1.82941L8.61966 1.82295L8.72187 1.78673L8.86602 1.81874"
                fill="#D2E1E3"
              />
              <path
                d="M8.71142 1.81874L8.85697 1.80234L9.0498 1.88106L9.25121 1.92555L9.40714 2.06222L9.09793 1.88131L9.09584 1.88499L8.94144 1.79412L8.86602 1.81874L9.30982 2.05746L9.85916 2.36805L10.4873 2.40751L11.1078 2.51449L11.2473 2.52831L11.3671 2.60212L11.4978 2.66146L11.5716 2.78585L11.7549 2.82279L11.9361 2.86979L12.009 3.05944L12.19 3.14766L12.3733 3.21831L12.4606 3.39633L12.6216 3.49376L12.8084 3.50947L12.8967 3.79535L13.0715 4.0369L13.3041 4.22115L13.5814 4.32358L13.5686 4.54251L13.5234 4.757L13.6175 4.95434L13.736 5.13766L13.5194 5.32982L13.4646 5.61621L13.2705 5.83698L13.2722 6.13266L13.2256 6.57389L13.0549 6.98257L12.8092 7.34781L12.6538 7.76083L12.2859 7.95941L11.8814 7.8569L11.4954 7.90632L11.1078 7.94175L10.7839 8.02023L10.4565 8.08229L10.1739 7.90259L9.87095 7.76083L9.62833 7.80725L9.39852 7.71574L9.16968 7.65213L8.94332 7.57991L8.6466 7.41142L8.38365 7.19279L8.04721 7.2638L7.7065 7.2181L7.66725 7.01197L7.51103 6.87409L7.32393 6.77997L7.24267 6.58493L7.20333 6.45836L7.24244 6.33174L7.19715 6.20681L7.08808 6.13266L7.04382 5.88657L7.13649 5.65471L7.13633 5.40078L6.98261 5.20025L6.89964 5.05025L6.84215 4.88847L6.82644 4.71781L6.81476 4.54685L6.75684 4.37038L6.8161 4.19434L6.90593 4.04337L7.00318 3.89716L7.00962 3.70332L7.1267 3.54989L7.29656 3.4741L7.42571 3.33905L7.46687 3.1653L7.45717 2.98691L7.5847 2.86474L7.68353 2.71781L7.72043 2.61803L7.81071 2.56342L7.90476 2.52319L7.97021 2.44376L8.04578 2.38026L8.06476 2.28264L8.05745 2.18725L8.08776 2.09663L8.18839 2.06746L8.28863 2.03695L8.32109 1.92825L8.41686 1.86927L8.51454 1.82941L8.61966 1.82295L8.72187 1.78673L8.86602 1.81874"
                stroke="white"
                stroke-width="0.0626657"
              />
            </g>
            <g id="path1856">
              <path
                d="M1.05854 8.91498L1.9872 9.24735L2.29537 9.6202C2.49224 9.73245 2.35031 9.65153 2.91379 9.97281L3.22299 10.5017L3.84141 10.8543L4.45982 11.2069H5.07824L5.38745 11.0306L5.69665 10.8543L6.0333 10.6474L6.30523 10.5815L6.56572 10.6829L6.62027 11.1231L6.66288 11.5646L6.49741 11.9808L6.22983 12.3416L5.89879 12.5331L5.65604 12.8264L5.29134 12.9317L4.91201 12.954L4.78162 13.1287L4.76776 13.3454L4.59273 13.4676L4.47276 13.643L4.36378 13.1445L4.00461 12.7781L3.57024 12.4925L3.3875 12.0098L2.45184 11.5996L1.71335 10.8994L1.37494 9.94187L0.700241 9.17729L0.803157 9.10168L0.930752 9.11456L1.02249 9.03216L1.05854 8.91498"
                fill="#F2E9DA"
              />
              <path
                d="M1.05854 8.91498L1.9872 9.24735L2.29537 9.6202C2.49224 9.73245 2.35031 9.65153 2.91379 9.97281L3.22299 10.5017L3.84141 10.8543L4.45982 11.2069H5.07824L5.38745 11.0306L5.69665 10.8543L6.0333 10.6474L6.30523 10.5815L6.56572 10.6829L6.62027 11.1231L6.66288 11.5646L6.49741 11.9808L6.22983 12.3416L5.89879 12.5331L5.65604 12.8264L5.29134 12.9317L4.91201 12.954L4.78162 13.1287L4.76776 13.3454L4.59273 13.4676L4.47276 13.643L4.36378 13.1445L4.00461 12.7781L3.57024 12.4925L3.3875 12.0098L2.45184 11.5996L1.71335 10.8994L1.37494 9.94187L0.700241 9.17729L0.803157 9.10168L0.930752 9.11456L1.02249 9.03216L1.05854 8.91498"
                stroke="white"
                stroke-width="0.0617657"
              />
            </g>
            <path
              id="path1890"
              d="M2.20206 8.66369L2.25809 8.66986L2.31263 8.68366L2.36413 8.66165L2.41798 8.64563L2.45617 8.6081L2.50106 8.57826L2.5502 8.55534L2.59382 8.52376L2.63561 8.48547L2.64272 8.43039L2.69989 8.41945L2.73439 8.37425L2.78008 8.3437L2.79554 8.29229L2.81765 8.24626L2.8494 8.20574L2.97625 8.1089L3.13715 8.09111L3.29313 8.06917L3.44858 8.0944L3.60019 8.11476L3.74987 8.14558L3.8828 8.22731L4.0401 8.23874L4.18714 8.16711L4.34929 8.19554L4.49256 8.1236L4.57991 7.9928L4.65263 7.85665L4.78428 7.77063L4.94093 7.75166L5.07492 7.67131L5.13795 7.62819L5.20081 7.58485L5.23338 7.51693L5.25111 7.44413L5.31758 7.40556L5.39503 7.41071L5.45138 7.35835L5.52935 7.35083L5.56108 7.28307L5.63253 7.25473L5.66679 7.18935L5.73596 7.15886L5.77112 7.09784L5.78809 7.03001L5.81937 6.96776L5.8503 6.90538"
              stroke="white"
              stroke-width="0.0670012"
            />
            <path
              id="path1922"
              d="M5.23285 6.18227L5.21196 6.12177L5.19486 6.0601L5.21117 5.99786L5.21302 5.93357L5.19395 5.87182L5.17194 5.81104L5.12737 5.76345L5.07452 5.72499L5.02899 5.67223L4.96315 5.64829L4.89648 5.66272L4.82824 5.66349L4.79618 5.60533L4.7694 5.54462L4.70022 5.53316L4.6498 5.48497L4.60003 5.45528L4.54945 5.42695L4.49368 5.44379L4.43594 5.45191L4.39404 5.48996L4.35803 5.53348L4.29925 5.5294L4.24677 5.55585L4.19801 5.53056L4.14663 5.51091L4.09547 5.53432L4.03909 5.53362L3.99739 5.50126L3.94708 5.48479L3.9067 5.45078L3.85687 5.43275L3.80982 5.39324L3.74813 5.38999L3.71224 5.33988L3.65236 5.32353L3.59222 5.33404L3.53627 5.35823L3.48059 5.33285L3.41987 5.32453L3.3572 5.31754L3.30026 5.29077L3.27937 5.23154L3.23648 5.18528L3.23394 5.12427L3.22422 5.06395L3.18635 5.01477L3.13441 4.9803L3.08769 4.93241L3.03096 4.89659L2.96391 4.87553L2.92257 4.81927L2.8536 4.80944L2.79095 4.77932L2.72355 4.7932L2.65567 4.80459L2.58935 4.80804L2.52905 4.83549L2.46386 4.82816L2.39861 4.83479L2.33361 4.862L2.26365 4.85256L2.22437 4.90926L2.16527 4.9455L2.16845 4.88975L2.17955 4.835L2.15021 4.78705L2.13214 4.73395L2.13038 4.67748L2.11413 4.62331L2.08298 4.57526L2.036 4.54206L1.99027 4.50483L1.9311 4.50826L1.87818 4.49281L1.82604 4.47497L1.78552 4.43785L1.74951 4.39647L1.71708 4.35151L1.67189 4.31903L1.61112 4.3378L1.54748 4.33626L1.48175 4.33821L1.42866 4.37654L1.36972 4.40315L1.30807 4.42287L1.24526 4.40565L1.1801 4.40398L1.11782 4.38399L1.0744 4.33557L1.0132 4.31965L0.95415 4.29717L0.905672 4.25022L0.837955 4.2453L0.784311 4.20892L0.749329 4.15475"
              stroke="white"
              stroke-width="0.0617657"
            />
            <path
              id="path1956"
              d="M5.07824 1.51019L5.09417 1.55875L5.13948 1.5833L5.18054 1.60809L5.2182 1.6377L5.22111 1.68512L5.22858 1.73205L5.24958 1.77486L5.26431 1.82015L5.28888 1.86725L5.27528 1.91851L5.25799 1.9656L5.22679 2.0051L5.27213 2.0319L5.28994 2.08103L5.30901 2.12825L5.30178 2.17859L5.25301 2.2274L5.23687 2.29409L5.27542 2.35301L5.26734 2.42271L5.23307 2.47624L5.18839 2.52166L5.12623 2.54027L5.07554 2.58039L5.02343 2.61921L5.00013 2.67942L4.95566 2.72601L4.93981 2.78808L4.92303 2.85179L4.95045 2.91179L4.98275 2.9673L4.9846 3.03129L5.03121 3.0862L5.08181 3.13754L5.12228 3.19702L5.1671 3.25337L5.20563 3.32202L5.27293 3.36373L5.29896 3.43818L5.28327 3.51539L5.24726 3.58345L5.24582 3.66024L5.28973 3.7236L5.30063 3.7996L5.33532 3.86333L5.35928 3.93172L5.3695 4.00322L5.37225 4.07539L5.34141 4.10044L5.32193 4.13487L5.30098 4.16779L5.28552 4.20354L5.2508 4.22922L5.23941 4.27056L5.25421 4.31063L5.24202 4.35155L5.24124 4.39064L5.22374 4.42572L5.20504 4.45999L5.20114 4.49873L5.19045 4.53712L5.16967 4.57125L5.17878 4.60994L5.17843 4.64966L5.17805 4.76109L5.22802 4.86101L5.28698 4.95909L5.39302 5.00424L5.37545 5.10791L5.33119 5.2035L5.33748 5.30794L5.32496 5.41182L5.40718 5.48966L5.42386 5.60092L5.42132 5.70731L5.42217 5.81375L5.33788 5.88495L5.31632 5.99241L5.28634 6.09237L5.23286 6.18227"
              stroke="white"
              stroke-width="0.0617657"
            />
            <g
              value="temple"
              //   className="temple"
              //   id="flat"
              //   style={{
              //     cursor: "pointer",
              //   }}
              //   onClick={(value) => {
              //     // alert("Temple");
              //     console.log("temple");
              //     //   isWhichIcon("temple");
              //   }}
            >
              <path
                id="path2943"
                d="M3.54979 3.50676H3.77892V3.65191H3.54979V3.50676Z"
                fill="#B9B9B9"
              />
              <path
                id="path2945"
                d="M3.57062 3.5275H3.75809V3.56897H3.57062V3.5275Z"
                fill="#A8A8A8"
              />
              <path
                id="path2947"
                d="M3.75809 3.50676H3.84141V4.06661H3.75809V3.50676Z"
                fill="#C7463B"
              />
              <path
                id="path2949"
                d="M3.4873 2.94692C3.4873 2.92938 3.49342 2.91238 3.50458 2.89882C3.51576 2.88525 3.53131 2.87595 3.54859 2.87251L3.59145 2.86398C3.59145 2.89124 3.58508 2.91814 3.57283 2.94253L3.57062 2.94692L3.52896 2.96765L3.4873 2.94692Z"
                fill="#B9B9B9"
              />
              <path
                id="path2951"
                d="M3.07072 2.94692C3.07072 2.92938 3.06462 2.91238 3.05344 2.89882C3.04228 2.88525 3.02673 2.87595 3.00945 2.87251L2.96657 2.86398C2.96657 2.89124 2.97295 2.91814 2.9852 2.94253L2.9874 2.94692L3.02906 2.96765L3.07072 2.94692Z"
                fill="#B9B9B9"
              />
              <path
                id="path2953"
                d="M3.3415 2.96765H3.21652V2.92618C3.21652 2.90968 3.2231 2.89387 3.23482 2.88219C3.24655 2.87053 3.26244 2.86398 3.27901 2.86398C3.29558 2.86398 3.31148 2.87053 3.32319 2.88219C3.33491 2.89387 3.3415 2.90968 3.3415 2.92618V2.96765Z"
                fill="#B9B9B9"
              />
              <path
                id="path2955"
                d="M2.77911 3.50676H3.00823V3.65191H2.77911V3.50676Z"
                fill="#B9B9B9"
              />
              <path
                id="path2957"
                d="M3.50813 3.67264H3.46647C3.4499 3.67264 3.43401 3.66609 3.4223 3.65442C3.41057 3.64276 3.40398 3.62694 3.40398 3.61044C3.38741 3.61044 3.37153 3.60388 3.35981 3.59222C3.34808 3.58055 3.34151 3.56473 3.34151 3.54823V3.50676H3.50813V3.67264Z"
                fill="#DC4D41"
              />
              <path
                id="path2959"
                d="M3.04988 3.67264H3.09154C3.10811 3.67264 3.12401 3.66609 3.13573 3.65442C3.14744 3.64276 3.15403 3.62694 3.15403 3.61044C3.1706 3.61044 3.1865 3.60388 3.19822 3.59222C3.20993 3.58055 3.21652 3.56473 3.21652 3.54823V3.50676H3.04988V3.67264Z"
                fill="#DC4D41"
              />
              <path
                id="path2961"
                d="M3.48729 3.27869H3.07071H2.94574V3.52751H2.98739V4.06661H3.07071V3.52751H3.48729V4.06661H3.57061V3.52751H3.59144V3.27869H3.48729Z"
                fill="#C7463B"
              />
              <path
                id="path2963"
                d="M2.79993 4.06661H2.71661V3.50676H2.79993V4.06661Z"
                fill="#C7463B"
              />
              <path
                id="path2965"
                d="M3.61227 3.02987V3.0506H2.94574V3.02987L2.98739 2.94693H3.57061L3.61227 3.02987Z"
                fill="#1F6C8C"
              />
              <path
                id="path2967"
                d="M2.94574 3.13353H3.61227V3.29941H2.94574V3.13353Z"
                fill="#DC4D41"
              />
              <path
                id="rect2969"
                d="M3.44497 3.27869H3.11303C3.08966 3.27869 3.07071 3.29755 3.07071 3.32081V3.40243C3.07071 3.42569 3.08966 3.44457 3.11303 3.44457H3.44497C3.46835 3.44457 3.4873 3.42569 3.4873 3.40243V3.32081C3.4873 3.29755 3.46835 3.27869 3.44497 3.27869Z"
                fill="#CDCDCD"
              />
              <path
                id="path2971"
                d="M3.4873 3.36163V3.27869H3.40398C3.40398 3.30067 3.41277 3.32178 3.42839 3.33734C3.44401 3.35288 3.4652 3.36163 3.4873 3.36163Z"
                fill="#EA9D2D"
              />
              <path
                id="path2973"
                d="M3.4873 3.36162V3.44456H3.40398C3.40398 3.42255 3.41277 3.40147 3.42839 3.38591C3.44401 3.37035 3.4652 3.36162 3.4873 3.36162Z"
                fill="#EA9D2D"
              />
              <path
                id="path2975"
                d="M3.07071 3.36163V3.27869H3.15403C3.15403 3.30067 3.14525 3.32178 3.12963 3.33734C3.11399 3.35288 3.09281 3.36163 3.07071 3.36163Z"
                fill="#EA9D2D"
              />
              <path
                id="path2977"
                d="M3.07071 3.36162V3.44456H3.15403C3.15403 3.42255 3.14525 3.40147 3.12963 3.38591C3.11399 3.37035 3.09281 3.36162 3.07071 3.36162Z"
                fill="#EA9D2D"
              />
              <path
                id="path2979"
                d="M3.57062 3.40309H3.84141V3.5275H3.57062V3.40309Z"
                fill="#DC4D41"
              />
              <path
                id="path2981"
                d="M2.71661 3.38235H2.98739V3.54823H2.71661V3.38235Z"
                fill="#DC4D41"
              />
              <path
                id="path2983"
                d="M3.7581 3.32015C3.76132 3.32015 3.76452 3.3194 3.76739 3.31795L3.81346 3.29503C3.82814 3.28778 3.8405 3.27658 3.84913 3.26269C3.85775 3.2488 3.86228 3.23279 3.86224 3.21647C3.86224 3.21098 3.86004 3.20569 3.85612 3.20181C3.85223 3.19791 3.84693 3.19574 3.84141 3.19574C3.83588 3.19574 3.83058 3.19791 3.82668 3.20181C3.82276 3.20569 3.82058 3.21098 3.82058 3.21647C3.82061 3.22509 3.8182 3.23355 3.81366 3.24087C3.8091 3.2482 3.80258 3.25411 3.79483 3.25794L3.74877 3.28087C3.74457 3.28295 3.7412 3.2864 3.73921 3.29063C3.73723 3.29486 3.73674 3.29964 3.73782 3.30419C3.7389 3.30874 3.74149 3.31278 3.74517 3.31567C3.74885 3.31857 3.75341 3.32015 3.7581 3.32015V3.32015Z"
                fill="#EA9D2D"
              />
              <path
                id="path2985"
                d="M3.57062 3.27869V3.4031H3.88307L3.79975 3.27869H3.57062Z"
                fill="#3B869E"
              />
              <path
                id="path2987"
                d="M3.67056 3.27869L3.75387 3.4031H3.80397L3.72065 3.27869H3.67056Z"
                fill="#1F6C8C"
              />
              <path
                id="path2989"
                d="M3.57062 3.27869V3.2787C3.57062 3.2828 3.57183 3.2868 3.57411 3.29019L3.64972 3.4031H3.69981L3.61649 3.27869H3.57062Z"
                fill="#1F6C8C"
              />
              <path
                id="path2991"
                d="M2.79992 3.32015C2.79669 3.32015 2.79351 3.3194 2.79061 3.31795L2.74455 3.29503C2.72987 3.28778 2.71751 3.27658 2.70889 3.26269C2.70027 3.2488 2.69573 3.23279 2.69579 3.21647C2.69579 3.21098 2.69799 3.20569 2.70189 3.20181C2.7058 3.19791 2.71109 3.19574 2.71662 3.19574C2.72214 3.19574 2.72743 3.19791 2.73135 3.20181C2.73524 3.20569 2.73745 3.21098 2.73745 3.21647C2.73742 3.22509 2.73981 3.23355 2.74437 3.24087C2.74891 3.2482 2.75544 3.25411 2.7632 3.25794L2.80924 3.28087C2.81344 3.28295 2.81681 3.2864 2.8188 3.29063C2.82079 3.29486 2.82128 3.29964 2.82021 3.30419C2.81913 3.30874 2.81654 3.31278 2.81285 3.31567C2.80917 3.31857 2.80461 3.32015 2.79992 3.32015V3.32015Z"
                fill="#EA9D2D"
              />
              <path
                id="path2993"
                d="M3.13321 3.19574H3.17487V3.23721H3.13321V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path2995"
                d="M3.21652 3.19574H3.25818V3.23721H3.21652V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path2997"
                d="M3.29985 3.19574H3.34151V3.23721H3.29985V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path2999"
                d="M3.38315 3.19574H3.42481V3.23721H3.38315V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path3001"
                d="M3.46648 3.19574H3.50814V3.23721H3.46648V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path3003"
                d="M3.04988 3.19574H3.09154V3.23721H3.04988V3.19574Z"
                fill="#A83B32"
              />
              <path
                id="path3005"
                d="M3.6956 3.15427H2.86242C2.82926 3.15427 2.79749 3.14116 2.77404 3.11783C2.7506 3.09449 2.73744 3.06286 2.73744 3.02986V2.96765C2.80559 3.00835 2.88357 3.02986 2.96305 3.02986H3.59495C3.67443 3.02986 3.75242 3.00835 3.82058 2.96765V3.02986C3.82058 3.06286 3.8074 3.09449 3.78397 3.11783C3.76053 3.14116 3.72874 3.15427 3.6956 3.15427Z"
                fill="#3B869E"
              />
              <path
                id="path3007"
                d="M3.26064 2.94693L3.219 3.02987H3.17242L3.21406 2.94693H3.26064Z"
                fill="#1B5E7A"
              />
              <path
                id="path3009"
                d="M3.38562 3.02987H3.33904L3.29736 2.94693H3.34397L3.38562 3.02987Z"
                fill="#1B5E7A"
              />
              <path
                id="path3011"
                d="M3.17731 2.94693L3.13567 3.02987H3.08907L3.13073 2.94693H3.17731Z"
                fill="#1B5E7A"
              />
              <path
                id="path3013"
                d="M3.09399 2.94693L3.05236 3.02987H3.00575L3.04741 2.94693H3.09399Z"
                fill="#1B5E7A"
              />
              <path
                id="path3015"
                d="M3.46895 3.02987H3.42237L3.38071 2.94693H3.42729L3.46895 3.02987Z"
                fill="#1B5E7A"
              />
              <path
                id="path3017"
                d="M3.55226 3.02987H3.50568L3.46402 2.94693H3.5106L3.55226 3.02987Z"
                fill="#1B5E7A"
              />
              <path
                id="path3019"
                d="M3.57062 3.44456H3.6956V3.48604H3.57062V3.44456Z"
                fill="#A83B32"
              />
              <path
                id="path3021"
                d="M3.73726 3.44456H3.77892V3.48604H3.73726V3.44456Z"
                fill="#A83B32"
              />
              <path
                id="path3023"
                d="M2.98739 3.27869V3.4031H2.67496L2.75828 3.27869H2.98739Z"
                fill="#3B869E"
              />
              <path
                id="path3025"
                d="M2.88747 3.27869L2.80415 3.4031H2.75406L2.83736 3.27869H2.88747Z"
                fill="#1F6C8C"
              />
              <path
                id="path3027"
                d="M2.9874 3.27869V3.2787C2.98741 3.2828 2.9862 3.2868 2.98391 3.29019L2.9083 3.4031H2.8582L2.94152 3.27869H2.9874Z"
                fill="#1F6C8C"
              />
              <path
                id="path3029"
                d="M2.86243 3.44456H2.98739V3.48604H2.86243V3.44456Z"
                fill="#A83B32"
              />
              <path
                id="path3031"
                d="M2.77911 3.44456H2.82077V3.48604H2.77911V3.44456Z"
                fill="#A83B32"
              />
              <path
                id="path3033"
                d="M2.9874 3.56897H2.79994V3.5275H2.9874V3.56897Z"
                fill="#A8A8A8"
              />
              <path
                id="path3035"
                d="M2.9874 3.85925H3.07072V4.0666H2.9874V3.85925Z"
                fill="#EA9D2D"
              />
              <path
                id="path3037"
                d="M3.4873 3.85925H3.57062V4.0666H3.4873V3.85925Z"
                fill="#EA9D2D"
              />
              <path
                id="path3039"
                d="M3.75809 3.9422H3.84141V4.06661H3.75809V3.9422Z"
                fill="#EA9D2D"
              />
              <path
                id="path3041"
                d="M2.71661 3.9422H2.79993V4.06661H2.71661V3.9422Z"
                fill="#EA9D2D"
              />
              <g id="g3059">
                <path
                  id="path3043"
                  d="M3.07071 3.44455H3.4873V3.48602H3.07071V3.44455Z"
                  fill="#A83B32"
                />
                <path
                  id="path3045"
                  d="M2.94574 3.15427H3.61227V3.17492H2.94574V3.15427Z"
                  fill="#A83B32"
                />
                <path
                  id="path3047"
                  d="M2.71661 3.40309H2.98739V3.42376H2.71661V3.40309Z"
                  fill="#A83B32"
                />
                <path
                  id="path3049"
                  d="M3.57062 3.40309H3.84141V3.42376H3.57062V3.40309Z"
                  fill="#A83B32"
                />
                <path
                  id="path3051"
                  d="M2.71661 3.5275H2.79993V3.54817H2.71661V3.5275Z"
                  fill="#A83B32"
                />
                <path
                  id="path3053"
                  d="M3.75809 3.5275H3.84141V3.54817H3.75809V3.5275Z"
                  fill="#A83B32"
                />
                <path
                  id="path3055"
                  d="M2.9874 3.27867H3.07072V3.29934H2.9874V3.27867Z"
                  fill="#A83B32"
                />
                <path
                  id="path3057"
                  d="M3.48729 3.27867H3.57061V3.29934H3.48729V3.27867Z"
                  fill="#A83B32"
                />
              </g>
            </g>
            <g
              id="g3573"
              //   className="bar-grill"
              //   style={{
              //     cursor: "pointer",
              //   }}
              //   onClick={() => {
              //     alert("Bar");
              //   }}
            >
              <path
                id="path3501"
                d="M5.07757 11.8521C4.96222 11.8521 4.86838 11.9466 4.86838 12.0627V12.0849H5.28676V12.0627C5.28676 11.9466 5.19291 11.8521 5.07757 11.8521Z"
                fill="#0A789B"
              />
              <path
                id="path3503"
                d="M5.28675 12.0849V12.0627C5.28675 11.9466 5.19291 11.8521 5.07756 11.8521V12.0849H5.28675Z"
                fill="#08475E"
              />
              <path
                id="path3505"
                d="M5.07757 11.9186C5.00472 11.9186 4.94545 11.8589 4.94545 11.7856C4.94545 11.7123 5.00472 11.6526 5.07757 11.6526C5.15042 11.6526 5.20969 11.7123 5.20969 11.7856C5.20969 11.8589 5.15042 11.9186 5.07757 11.9186Z"
                fill="#FFD2AA"
              />
              <path
                id="path3507"
                d="M5.20968 11.7856C5.20968 11.7123 5.15041 11.6526 5.07756 11.6526V11.9186C5.15041 11.9186 5.20968 11.8589 5.20968 11.7856Z"
                fill="#FAC08F"
              />
              <path
                id="path3509"
                d="M4.29587 12.0849V12.6169C4.29587 12.6352 4.31066 12.6501 4.3289 12.6501H5.25373C5.27197 12.6501 5.28676 12.6352 5.28676 12.6169V12.0849H4.29587Z"
                fill="#985E33"
              />
              <path
                id="path3511"
                d="M4.79131 12.6501H5.25372C5.27196 12.6501 5.28675 12.6352 5.28675 12.6169V12.0849H4.79131V12.6501Z"
                fill="#814F2B"
              />
              <path
                id="path3513"
                d="M4.3399 11.5484H4.40596V11.6592H4.3399V11.5484Z"
                fill="#0A789B"
              />
              <path
                id="path3515"
                d="M4.69221 11.5484H4.75827V11.6592H4.69221V11.5484Z"
                fill="#0A789B"
              />
              <path
                id="path3517"
                d="M4.72525 11.5484H4.75828V11.6592H4.72525V11.5484Z"
                fill="#08475E"
              />
              <path
                id="path3519"
                d="M4.37292 11.5484H4.40595V11.6592H4.37292V11.5484Z"
                fill="#08475E"
              />
              <path
                id="path3521"
                d="M4.48578 11.8855C4.47951 11.8784 4.47049 11.8743 4.46102 11.8743H4.3289C4.31942 11.8743 4.31041 11.8784 4.30414 11.8855C4.29787 11.8927 4.29495 11.9022 4.29612 11.9116L4.31814 12.089H4.47177L4.49379 11.9116C4.49497 11.9022 4.49205 11.8927 4.48578 11.8855Z"
                fill="#E7F1F9"
              />
              <path
                id="path3523"
                d="M4.77203 11.8855C4.76576 11.8784 4.75674 11.8743 4.74727 11.8743H4.61515C4.60568 11.8743 4.59666 11.8784 4.59039 11.8855C4.58412 11.8927 4.5812 11.9022 4.58238 11.9116L4.6044 12.089H4.75803L4.78005 11.9116C4.78122 11.9022 4.7783 11.8927 4.77203 11.8855V11.8855Z"
                fill="#E7F1F9"
              />
              <g id="g3527">
                <path
                  id="path3525"
                  d="M4.77203 11.8855C4.76577 11.8784 4.75675 11.8743 4.74727 11.8743H4.68121V12.089H4.75803L4.78005 11.9116C4.78122 11.9022 4.77831 11.8927 4.77203 11.8855Z"
                  fill="#D5E7F6"
                />
              </g>
              <g id="g3531">
                <path
                  id="path3529"
                  d="M4.48578 11.8855C4.47951 11.8784 4.47049 11.8743 4.46102 11.8743H4.39496V12.089H4.47177L4.49379 11.9116C4.49497 11.9022 4.49205 11.8927 4.48578 11.8855Z"
                  fill="#D5E7F6"
                />
              </g>
              <path
                id="path3533"
                d="M4.48303 11.8033H4.26283C4.24459 11.8033 4.2298 11.7884 4.2298 11.7701C4.2298 11.6906 4.29401 11.626 4.37293 11.626C4.45185 11.626 4.51606 11.6906 4.51606 11.7701C4.51606 11.7884 4.50127 11.8033 4.48303 11.8033Z"
                fill="#FFDD54"
              />
              <path
                id="path3535"
                d="M4.83535 11.8033H4.61515C4.59691 11.8033 4.58212 11.7884 4.58212 11.7701C4.58212 11.6906 4.64633 11.626 4.72525 11.626C4.80417 11.626 4.86838 11.6906 4.86838 11.7701C4.86838 11.7884 4.85359 11.8033 4.83535 11.8033Z"
                fill="#FFDD54"
              />
              <g id="g3545">
                <path
                  id="path3537"
                  d="M5.12156 12.6501C5.10614 12.6501 5.09235 12.6392 5.08921 12.6234L5.04517 12.4017C5.04159 12.3837 5.0532 12.3662 5.07108 12.3626C5.08897 12.359 5.10637 12.3707 5.10995 12.3887L5.15399 12.6103C5.15757 12.6284 5.14596 12.6459 5.12808 12.6495C5.12589 12.6499 5.12371 12.6501 5.12156 12.6501V12.6501Z"
                  fill="#D5E7F6"
                />
                <path
                  id="path3539"
                  d="M4.8574 12.6501C4.85525 12.6501 4.85307 12.6499 4.85088 12.6495C4.833 12.6459 4.8214 12.6284 4.82497 12.6103L4.86901 12.3887C4.87259 12.3707 4.88999 12.359 4.90788 12.3626C4.92577 12.3662 4.93737 12.3837 4.93379 12.4017L4.88975 12.6234C4.88661 12.6392 4.87282 12.6501 4.8574 12.6501Z"
                  fill="#E7F1F9"
                />
                <path
                  id="path3541"
                  d="M5.09957 12.4063H4.87938C4.84897 12.4063 4.82433 12.3815 4.82433 12.3509V12.3065C4.82433 12.2759 4.84897 12.2511 4.87938 12.2511H5.09957C5.12998 12.2511 5.15462 12.2759 5.15462 12.3065V12.3509C5.15462 12.3815 5.12998 12.4063 5.09957 12.4063Z"
                  fill="#FF6378"
                />
                <path
                  id="path3543"
                  d="M5.09959 12.2511H4.98949V12.4063H5.09959C5.12999 12.4063 5.15464 12.3815 5.15464 12.3509V12.3065C5.15464 12.2759 5.12999 12.2511 5.09959 12.2511Z"
                  fill="#C63D4F"
                />
              </g>
              <g id="g3555">
                <path
                  id="path3547"
                  d="M4.72522 12.6501C4.70979 12.6501 4.696 12.6392 4.69287 12.6234L4.64883 12.4017C4.64525 12.3837 4.65685 12.3662 4.67474 12.3626C4.69262 12.359 4.71003 12.3707 4.7136 12.3887L4.75764 12.6103C4.76122 12.6284 4.74962 12.6459 4.73173 12.6495C4.72954 12.6499 4.72736 12.6501 4.72522 12.6501Z"
                  fill="#D5E7F6"
                />
                <path
                  id="path3549"
                  d="M4.46105 12.6501C4.4589 12.6501 4.45672 12.6499 4.45454 12.6495C4.43665 12.6459 4.42505 12.6284 4.42863 12.6103L4.47267 12.3887C4.47624 12.3707 4.49364 12.359 4.51153 12.3626C4.52942 12.3662 4.54102 12.3837 4.53744 12.4017L4.4934 12.6234C4.49026 12.6392 4.47647 12.6501 4.46105 12.6501Z"
                  fill="#E7F1F9"
                />
                <path
                  id="path3551"
                  d="M4.70323 12.4063H4.48303C4.45263 12.4063 4.42798 12.3815 4.42798 12.3509V12.3065C4.42798 12.2759 4.45263 12.2511 4.48303 12.2511H4.70323C4.73363 12.2511 4.75828 12.2759 4.75828 12.3065V12.3509C4.75828 12.3815 4.73363 12.4063 4.70323 12.4063Z"
                  fill="#FF6378"
                />
                <path
                  id="path3553"
                  d="M4.70324 12.2511H4.59314V12.4063H4.70324C4.73364 12.4063 4.75829 12.3815 4.75829 12.3509V12.3065C4.75829 12.2759 4.73364 12.2511 4.70324 12.2511Z"
                  fill="#C63D4F"
                />
              </g>
              <path
                id="path3557"
                d="M5.32199 11.5817H4.26063C4.24239 11.5817 4.2276 11.5668 4.2276 11.5484C4.2276 11.53 4.24239 11.5152 4.26063 11.5152H5.32199C5.34023 11.5152 5.35502 11.53 5.35502 11.5484C5.35502 11.5668 5.34023 11.5817 5.32199 11.5817Z"
                fill="#E7F1F9"
              />
              <path
                id="path3559"
                d="M5.32198 11.5152H4.79131V11.5817H5.32198C5.34023 11.5817 5.35501 11.5668 5.35501 11.5484C5.35501 11.53 5.34023 11.5152 5.32198 11.5152Z"
                fill="#D5E7F6"
              />
              <path
                id="path3561"
                d="M5.32199 12.1181H4.26063C4.24239 12.1181 4.2276 12.1032 4.2276 12.0849C4.2276 12.0665 4.24239 12.0516 4.26063 12.0516H5.32199C5.34023 12.0516 5.35502 12.0665 5.35502 12.0849C5.35502 12.1032 5.34023 12.1181 5.32199 12.1181Z"
                fill="#FFDD54"
              />
              <path
                id="path3563"
                d="M5.32198 12.0516H4.79131V12.1181H5.32198C5.34023 12.1181 5.35501 12.1032 5.35501 12.0849C5.35501 12.0665 5.34023 12.0516 5.32198 12.0516Z"
                fill="#FFB454"
              />
              <g id="g3567">
                <path
                  id="path3565"
                  d="M4.72525 11.626V11.8033H4.83535C4.85359 11.8033 4.86838 11.7884 4.86838 11.7701C4.86838 11.6906 4.80417 11.626 4.72525 11.626Z"
                  fill="#FFB454"
                />
              </g>
              <g id="g3571">
                <path
                  id="path3569"
                  d="M4.37292 11.626V11.8033H4.48302C4.50127 11.8033 4.51605 11.7884 4.51605 11.7701C4.51605 11.6906 4.45185 11.626 4.37292 11.626Z"
                  fill="#FFB454"
                />
              </g>
            </g>
            <path
              id="rect869-9"
              d="M3.66074 6.30899H2.16683C1.94873 6.30899 1.7719 6.48057 1.7719 6.69223C1.7719 6.90391 1.94873 7.07549 2.16683 7.07549H3.66074C3.87887 7.07549 4.05568 6.90391 4.05568 6.69223C4.05568 6.48057 3.87887 6.30899 3.66074 6.30899Z"
              fill="#BAB5F8"
            />
            <path
              id="rect869-9-9"
              d="M6.00587 8.50108H4.51196C4.29385 8.50108 4.11702 8.67267 4.11702 8.88432C4.11702 9.096 4.29385 9.26758 4.51196 9.26758H6.00587C6.22399 9.26758 6.4008 9.096 6.4008 8.88432C6.4008 8.67267 6.22399 8.50108 6.00587 8.50108V8.50108Z"
              fill="#BAB5F8"
            />
            <path
              id="rect869-9-9-7"
              d="M5.99609 3.26767L7.33725 2.61779C7.53306 2.52291 7.61528 2.29194 7.52087 2.10193C7.42646 1.9119 7.19118 1.83478 6.99537 1.92966L5.6542 2.57954C5.45838 2.67443 5.37618 2.90539 5.47059 3.09542C5.565 3.28544 5.80026 3.36256 5.99609 3.26767V3.26767Z"
              fill="#BAB5F8"
            />
            <g
              id="flat-8"
              //   className="movie-theater"
              //   style={{
              //     cursor: "pointer",
              //   }}
              //   onClick={() => {
              //     alert("Movie Theater");
              //   }}
            >
              <path
                id="path2300"
                d="M10.5743 4.84866H9.4597C9.45964 4.79264 9.46992 4.737 9.49012 4.68407C9.49495 4.67079 9.5006 4.65777 9.50707 4.64508C9.5316 4.59406 9.56535 4.54712 9.60692 4.50619C9.61737 4.49587 9.62852 4.48575 9.6399 4.47648C9.68277 4.44053 9.73169 4.411 9.7848 4.38902C9.79871 4.38298 9.81297 4.37763 9.82752 4.373C9.88091 4.35533 9.937 4.34531 9.99379 4.34329C10.0014 4.34308 10.0091 4.34286 10.017 4.34286C10.0249 4.34286 10.0326 4.34308 10.0402 4.34329C10.097 4.34531 10.1531 4.35533 10.2065 4.373C10.2211 4.37769 10.2354 4.38303 10.2495 4.38902C10.3025 4.41106 10.3513 4.44058 10.3941 4.47648C10.4055 4.48575 10.4166 4.49587 10.4271 4.50619C10.4687 4.54712 10.5024 4.59406 10.5269 4.64508C10.5334 4.65777 10.5391 4.67079 10.5439 4.68407C10.5641 4.737 10.5744 4.79264 10.5743 4.84866V4.84866Z"
                fill="#50B4F8"
              />
              <path
                id="path2302"
                d="M10.017 4.49039C9.91232 4.49039 9.81191 4.52813 9.73788 4.59532C9.66384 4.66251 9.62225 4.75364 9.62225 4.84866H10.4118C10.4118 4.75364 10.3702 4.66251 10.2961 4.59532C10.2221 4.52813 10.1217 4.49039 10.017 4.49039V4.49039Z"
                fill="#4F97D5"
              />
              <path
                id="path2304"
                d="M10.017 4.63791C9.95543 4.63791 9.89637 4.66011 9.85282 4.69964C9.80927 4.73916 9.78481 4.79276 9.78481 4.84866H10.2492C10.2492 4.79276 10.2248 4.73916 10.1812 4.69964C10.1377 4.66011 10.0786 4.63791 10.017 4.63791Z"
                fill="#87CEE9"
              />
              <path
                id="path2306"
                d="M10.5439 4.68407L10.0806 4.84866L10.0254 4.86826H10.0087L9.95339 4.84866L9.49013 4.68407C9.49495 4.67079 9.50061 4.65777 9.50708 4.64508L9.92204 4.79239L9.60693 4.50619C9.61738 4.49587 9.62853 4.48575 9.6399 4.47648L9.95176 4.75972L9.7848 4.38902C9.79871 4.38298 9.81298 4.37763 9.82753 4.373L9.99379 4.74139V4.34329C10.0015 4.34308 10.0091 4.34286 10.017 4.34286C10.0249 4.34286 10.0326 4.34308 10.0402 4.34329V4.74139L10.2065 4.373C10.2211 4.37769 10.2354 4.38303 10.2495 4.38902L10.0823 4.75972L10.3941 4.47648C10.4055 4.48575 10.4166 4.49587 10.4271 4.50619L10.112 4.79239L10.5269 4.64508C10.5334 4.65777 10.5391 4.67079 10.5439 4.68407Z"
                fill="#2D75BB"
              />
              <path
                id="path2308"
                d="M9.3436 4.84866H10.6904V5.01726H9.3436V4.84866Z"
                fill="#D3843D"
              />
              <path
                id="path2310"
                d="M9.39005 5.01726H10.644V5.5652H9.39005V5.01726Z"
                fill="#F9BB4B"
              />
              <path
                id="path2312"
                d="M9.78481 5.22801H10.2492V5.43876H9.78481V5.22801Z"
                fill="#66342E"
              />
              <path
                id="path2314"
                d="M9.78481 5.43875H10.2492V5.5652H9.78481V5.43875Z"
                fill="#D3843D"
              />
              <path
                id="path2316"
                d="M9.94735 5.3123C9.96582 5.3123 9.98354 5.31896 9.99661 5.33082C10.0097 5.34268 10.017 5.35876 10.017 5.37553V5.43875H9.87769V5.37553C9.87769 5.35876 9.88503 5.34268 9.89809 5.33082C9.91115 5.31896 9.92887 5.3123 9.94735 5.3123Z"
                fill="#50B4F8"
              />
              <path
                id="path2318"
                d="M10.0867 5.3123C10.1052 5.3123 10.1229 5.31896 10.1359 5.33082C10.149 5.34268 10.1563 5.35876 10.1563 5.37553V5.43875H10.017V5.37553C10.017 5.35876 10.0244 5.34268 10.0374 5.33082C10.0505 5.31896 10.0682 5.3123 10.0867 5.3123Z"
                fill="#4F97D5"
              />
              <path
                id="path2320"
                d="M9.39005 5.22801H9.6687V5.56521H9.39005V5.22801Z"
                fill="#DD3E46"
              />
              <path
                id="path2322"
                d="M9.50615 5.22801H9.55259V5.56521H9.50615V5.22801Z"
                fill="#F98C96"
              />
              <path
                id="path2324"
                d="M10.3653 5.22801H10.644V5.56521H10.3653V5.22801Z"
                fill="#DD3E46"
              />
              <path
                id="path2326"
                d="M10.4814 5.22801H10.5279V5.56521H10.4814V5.22801Z"
                fill="#F98C96"
              />
              <g id="g2346">
                <path
                  id="path2328"
                  d="M9.43648 4.91188H9.48292V4.95403H9.43648V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2330"
                  d="M9.57581 4.91188H9.62225V4.95403H9.57581V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2332"
                  d="M9.71513 4.91188H9.76158V4.95403H9.71513V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2334"
                  d="M9.85446 4.91188H9.9009V4.95403H9.85446V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2336"
                  d="M10.1331 4.91188H10.1796V4.95403H10.1331V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2338"
                  d="M10.2724 4.91188H10.3189V4.95403H10.2724V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2340"
                  d="M10.4118 4.91188H10.4582V4.95403H10.4118V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2342"
                  d="M10.5511 4.91188H10.5975V4.95403H10.5511V4.91188Z"
                  fill="#FCF05A"
                />
                <path
                  id="path2344"
                  d="M9.99379 4.91188H10.0402V4.95403H9.99379V4.91188Z"
                  fill="#FCF05A"
                />
              </g>
              <path
                id="path2348"
                d="M9.97057 5.01726H10.0635V5.14371H9.97057V5.01726Z"
                fill="#DD3E46"
              />
              <path
                id="path2350"
                d="M10.0634 5.01726H10.1563V5.14371H10.0634V5.01726Z"
                fill="#F98C96"
              />
              <path
                id="path2352"
                d="M10.1563 5.01726H10.2492V5.14371H10.1563V5.01726Z"
                fill="#DD3E46"
              />
              <path
                id="path2354"
                d="M9.87769 5.01726H9.97057V5.14371H9.87769V5.01726Z"
                fill="#F98C96"
              />
              <path
                id="path2356"
                d="M9.78481 5.01726H9.87769V5.14371H9.78481V5.01726Z"
                fill="#DD3E46"
              />
            </g>
            <path
              id="rect869-9-9-7-6"
              d="M10.6948 7.39182L12.1869 7.43886C12.4047 7.44573 12.5729 7.27924 12.5625 7.06701C12.552 6.85475 12.3669 6.67713 12.1491 6.67026L10.657 6.62322C10.4391 6.61635 10.271 6.78284 10.2814 6.9951C10.2918 7.20733 10.4769 7.38496 10.6948 7.39182V7.39182Z"
              fill="#6DB39A"
              fill-opacity="0.67451"
            />
            <path
              id="rect869-9-9-7-6-9"
              d="M8.37076 3.63403L9.8629 3.68106C10.0807 3.68793 10.2489 3.52145 10.2385 3.30921C10.228 3.09695 10.043 2.91933 9.82511 2.91246L8.33297 2.86542C8.11511 2.85856 7.94696 3.02504 7.9574 3.2373C7.96784 3.44954 8.1529 3.62716 8.37076 3.63403Z"
              fill="#6DB39A"
              fill-opacity="0.67451"
            />
            <path
              id="path2504"
              d="M13.2722 5.82965L13.2747 5.85373L13.275 5.87795L13.291 5.89626L13.3063 5.91521L13.3083 5.93859L13.3188 5.95966L13.3168 5.98304L13.3236 6.00552L13.3219 6.02953L13.3273 6.05301L13.3305 6.07832L13.3157 6.09923L13.3247 6.12245L13.3223 6.1472L13.3289 6.1724L13.3509 6.18655L13.3134 6.31795L13.3424 6.45146L13.3982 6.57708L13.5102 6.65828L13.634 6.72115L13.7721 6.70361L13.8435 6.81705L13.9518 6.89709L14.0127 7.01197L13.9826 7.13818L14.0354 7.25109L14.131 7.33205L14.1914 7.44044L14.1909 7.56421L14.1626 7.68111L14.1542 7.80102L14.2119 7.84874L14.2743 7.89022L14.3394 7.93614L14.4191 7.92989L14.4976 7.92934L14.5736 7.94889L14.6496 7.98191L14.6854 8.05591L14.7232 8.12384L14.7717 8.18488L14.8316 8.23473L14.8957 8.27913L14.9587 8.3376L14.9663 8.42258L14.9493 8.50071L14.9434 8.58045L14.9513 8.64148L14.9886 8.6908L15.0045 8.74908L15.0387 8.79903L15.0707 8.85148L15.0957 8.90748L15.1126 8.96822L15.0984 9.02963L15.1344 9.08229L15.1602 9.14052L15.1619 9.20562L15.1334 9.26436L15.1086 9.32407L15.1314 9.3846L15.152 9.44123L15.1689 9.49902L15.247 9.63538L15.3826 9.71667L15.4667 9.84533L15.5116 9.99181L15.6704 10.0447L15.8337 10.008L15.9739 10.0933L16.0684 10.2265L16.1981 10.3067L16.2901 10.4275L16.4313 10.4818L16.5816 10.5013L16.7333 10.5246L16.8478 10.6256L17.0016 10.6029L17.1373 10.678"
              stroke="white"
              stroke-width="0.0617657"
            />
            <path
              id="rect869-9-9-7-6-0"
              d="M14.2625 6.9008L15.2241 8.02855C15.3645 8.1932 15.6023 8.2055 15.7552 8.05601C15.9081 7.90651 15.9182 7.65184 15.7778 7.48719L14.8162 6.35944C14.6758 6.19478 14.438 6.18249 14.2851 6.33199C14.1322 6.48148 14.122 6.73614 14.2625 6.9008Z"
              fill="#D8AAD1"
              fill-opacity="0.67451"
            />
            <g
              id="flat-0"
              className="ski-resort"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                alert("Ski Resort");
              }}
            >
              <path
                id="path3184"
                d="M13.0405 9.26007L13.7586 10.0109V10.6275L13.1433 10.0378H12.2715V9.90372L12.7835 9.36837L13.0405 9.26007Z"
                fill="#92CDDE"
              />
              <path
                id="path3186"
                d="M13.5789 9.3405L13.7586 9.52842V10.011L13.2715 9.50161L13.3484 9.42119L13.5789 9.3405Z"
                fill="#50B3C9"
              />
              <path
                id="path3188"
                d="M13.1451 9.36945L13.1176 9.39438C13.104 9.40846 13.0855 9.41636 13.0664 9.41636C13.0472 9.41636 13.0287 9.40846 13.0151 9.39438C13.0014 9.38029 12.983 9.37239 12.9638 9.37239C12.9446 9.37239 12.9262 9.38029 12.9125 9.39438C12.8989 9.40854 12.8804 9.41649 12.8612 9.41649C12.842 9.41649 12.8236 9.40854 12.8099 9.39438L12.7835 9.36837L12.8871 9.26007C12.9075 9.23883 12.935 9.2269 12.9638 9.2269C12.9925 9.2269 13.0201 9.23883 13.0405 9.26007L13.1451 9.36945Z"
                fill="#F4F4E6"
              />
              <path
                id="path3190"
                d="M13.6574 9.42253L13.6304 9.448C13.6202 9.45864 13.6064 9.46462 13.592 9.46462C13.5776 9.46462 13.5637 9.45864 13.5535 9.448C13.5398 9.43392 13.5214 9.42602 13.5022 9.42602C13.483 9.42602 13.4646 9.43392 13.451 9.448C13.4459 9.45329 13.4399 9.45749 13.4333 9.46036C13.4267 9.46322 13.4196 9.4647 13.4125 9.4647C13.4053 9.4647 13.3983 9.46322 13.3917 9.46036C13.3851 9.45749 13.3791 9.45329 13.374 9.448L13.3484 9.42119L13.4256 9.34077C13.4459 9.31949 13.4734 9.30752 13.5022 9.30746C13.5309 9.30741 13.5585 9.3193 13.5789 9.3405L13.6574 9.42253Z"
                fill="#F4F4E6"
              />
              <path
                id="path3192"
                d="M12.8869 10.0378V9.79649L12.7074 9.60884L12.5535 9.76969V10.0378H12.8869Z"
                fill="#D3843D"
              />
              <path
                id="path3194"
                d="M12.6817 9.74287H12.733V9.79649H12.6817V9.74287Z"
                fill="#F9BB4B"
              />
              <path
                id="path3196"
                d="M12.6305 9.85011H12.8099V9.90373H12.6305V9.85011Z"
                fill="#F9BB4B"
              />
              <path
                id="path3198"
                d="M13.2202 9.90372H12.8869V9.79649H13.1176L13.2202 9.90372Z"
                fill="#66342E"
              />
              <path
                id="path3200"
                d="M13.1176 9.90373H13.1689V10.1228H13.1176V9.90373Z"
                fill="#D3843D"
              />
              <path
                id="path3202"
                d="M12.9638 9.90373H13.0151V10.0378H12.9638V9.90373Z"
                fill="#D3843D"
              />
              <path
                id="path3204"
                d="M12.7074 9.60884L12.5023 9.8233L12.4253 9.74288L12.7074 9.448L13.0407 9.7965H12.8869L12.7074 9.60884Z"
                fill="#AD6327"
              />
              <path
                id="path3206"
                d="M12.3228 9.28715C12.3092 9.28715 12.2961 9.2815 12.2865 9.27145C12.2769 9.26139 12.2715 9.24776 12.2715 9.23354C12.2706 9.22274 12.272 9.21186 12.2755 9.20167C12.279 9.19148 12.2847 9.18223 12.292 9.17456C12.2993 9.1669 12.3082 9.161 12.3179 9.1573C12.3277 9.15359 12.3381 9.15216 12.3484 9.15312H12.3741C12.3893 9.10218 12.4253 9.07269 12.5023 9.07269C12.5594 9.07269 12.6181 9.09768 12.6305 9.15312H12.6561C12.6663 9.15282 12.6764 9.15469 12.6859 9.15863C12.6953 9.16256 12.7039 9.16848 12.7111 9.176C12.7183 9.18353 12.724 9.19252 12.7278 9.20241C12.7315 9.2123 12.7333 9.2229 12.733 9.23354C12.733 9.24776 12.7276 9.26139 12.718 9.27145C12.7084 9.2815 12.6953 9.28715 12.6817 9.28715H12.3228Z"
                fill="#50B4F8"
              />
              <path
                id="path3208"
                d="M13.7586 10.6275H12.2715V10.0378H13.1433L13.7586 10.6275Z"
                fill="#CDEEF6"
              />
              <path
                id="circle3210"
                d="M12.5535 10.3595C12.5819 10.3595 12.6048 10.3355 12.6048 10.3058C12.6048 10.2762 12.5819 10.2522 12.5535 10.2522C12.5252 10.2522 12.5023 10.2762 12.5023 10.3058C12.5023 10.3355 12.5252 10.3595 12.5535 10.3595Z"
                fill="#FAFAFA"
              />
              <path
                id="path3212"
                d="M12.4327 10.3515L12.4689 10.3136L12.5459 10.394L12.5096 10.4319L12.4327 10.3515Z"
                fill="#D3843D"
              />
              <path
                id="path3214"
                d="M12.5352 10.4208L12.6378 10.3136L12.6741 10.3515L12.5715 10.4587L12.5352 10.4208Z"
                fill="#D3843D"
              />
              <path
                id="circle3216"
                d="M12.5535 10.5203C12.596 10.5203 12.6305 10.4843 12.6305 10.4399C12.6305 10.3955 12.596 10.3595 12.5535 10.3595C12.5111 10.3595 12.4766 10.3955 12.4766 10.4399C12.4766 10.4843 12.5111 10.5203 12.5535 10.5203Z"
                fill="#FAFAFA"
              />
            </g>
            <g
              id="g3182"
              className="cable-car"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                alert("Cable Car");
              }}
            >
              <path
                id="path3120"
                d="M14.0097 11.3728C14.0067 11.3517 14.0225 11.3324 14.0448 11.3296L15.19 11.1856C15.2124 11.1828 15.2329 11.1977 15.2359 11.2187C15.2389 11.2398 15.2232 11.2592 15.2008 11.262L14.0556 11.4059C14.0333 11.4087 14.0127 11.3939 14.0097 11.3728Z"
                fill="#708299"
              />
              <path
                id="path3122"
                d="M14.5819 11.4113H14.6637V11.6425H14.5819V11.4113Z"
                fill="#787680"
              />
              <path
                id="path3124"
                d="M14.9498 12.3744H14.2958C14.1606 12.3744 14.0506 12.2708 14.0506 12.1433V11.8351C14.0506 11.7076 14.1606 11.604 14.2958 11.604H14.9498C15.085 11.604 15.195 11.7076 15.195 11.8351V12.1433C15.195 12.2708 15.085 12.3744 14.9498 12.3744Z"
                fill="#FF6853"
              />
              <path
                id="path3126"
                d="M14.3367 12.1433H14.9089V12.2203H14.3367V12.1433Z"
                fill="#FFCB5A"
              />
              <path
                id="path3128"
                d="M14.868 11.2958C14.868 11.272 14.8642 11.2491 14.8571 11.2275L14.378 11.2877C14.3779 11.2904 14.3776 11.293 14.3776 11.2958C14.3776 11.3195 14.3814 11.3425 14.3885 11.3641L14.8676 11.3039C14.8677 11.3012 14.868 11.2985 14.868 11.2958V11.2958Z"
                fill="#68788E"
              />
              <path
                id="path3130"
                d="M14.7863 11.2958C14.7863 11.3809 14.7131 11.4499 14.6228 11.4499C14.5325 11.4499 14.4593 11.3809 14.4593 11.2958C14.4593 11.2107 14.5325 11.1417 14.6228 11.1417C14.7131 11.1417 14.7863 11.2107 14.7863 11.2958Z"
                fill="#00DDC2"
              />
              <path
                id="path3132"
                d="M14.4184 11.7581H14.8272V12.0662H14.4184V11.7581Z"
                fill="#E4EDFB"
              />
              <path
                id="path3134"
                d="M14.3367 11.7581H14.0649C14.0558 11.7822 14.0506 11.8081 14.0506 11.8351V12.0662H14.3367V11.7581Z"
                fill="#E4EDFB"
              />
              <path
                id="path3136"
                d="M14.9089 11.7581V12.0662H15.195V11.8351C15.195 11.8081 15.1898 11.7822 15.1807 11.7581H14.9089Z"
                fill="#E4EDFB"
              />
              <path
                id="path3138"
                d="M14.9498 12.2974H14.2958C14.1606 12.2974 14.0506 12.1937 14.0506 12.0662V12.1433C14.0506 12.2708 14.1606 12.3744 14.2958 12.3744H14.9498C15.085 12.3744 15.195 12.2708 15.195 12.1433V12.0662C15.195 12.1937 15.085 12.2974 14.9498 12.2974Z"
                fill="#F45747"
              />
              <g id="g3148">
                <path
                  id="path3140"
                  d="M14.1732 11.8351H14.2549V11.9121H14.1732V11.8351Z"
                  fill="white"
                />
                <path
                  id="path3142"
                  d="M14.6637 11.8351H14.7454V11.9121H14.6637V11.8351Z"
                  fill="white"
                />
                <path
                  id="path3144"
                  d="M15.0315 11.8351H15.1133V11.9121H15.0315V11.8351Z"
                  fill="white"
                />
                <path
                  id="path3146"
                  d="M14.5819 11.2573H14.6637V11.3343H14.5819V11.2573Z"
                  fill="white"
                />
              </g>
              <path
                id="path3150"
                d="M14.4184 11.7581H14.8272V11.8351H14.4184V11.7581Z"
                fill="#D7E1F2"
              />
              <path
                id="path3152"
                d="M14.0649 11.7581C14.0558 11.7822 14.0506 11.8081 14.0506 11.8351H14.3367V11.7581H14.0649Z"
                fill="#D7E1F2"
              />
              <path
                id="path3154"
                d="M15.1807 11.7581H14.9089V11.8351H15.195C15.195 11.8081 15.1898 11.7822 15.1807 11.7581Z"
                fill="#D7E1F2"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="18.66" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default HomePageSvg;
